module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyright"
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_0002"
    }
  }), _c('b', [_c('i', [_vm._v("Preaching Hebrews")])])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "i_Image2",
      "src": "images/logo.jpg"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("ACU Box 29138"), _c('br'), _vm._v("Abilene, TX 79699"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.acu.edu/acupress",
      "target": "_blank"
    }
  }, [_vm._v("www.acu.edu/acupress")])]), _vm._v(" "), _c('p', [_vm._v("Cover Design and Typesetting by Sarah Bales")]), _vm._v(" "), _c('p', [_vm._v("Copyright © 2003")]), _vm._v(" "), _c('p', [_vm._v("David Fleer and Dave Bland, editors")]), _vm._v(" "), _c('p', [_vm._v("All rights reserved. Except as provided in the Copyright Act of 1976, no part of this book may be reproduced, stored in a retrieval system, or transcribed, in any form or by any means, electronic, mechanical, photocopying, recording or otherwise, without prior written permission from the Abilene Christian University Press.")]), _vm._v(" "), _c('p', [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', [_vm._v("ISBN 0-89112-138-2")]), _vm._v(" "), _c('p', [_vm._v("Library of Congress Card Number: 2003105898")]), _vm._v(" "), _c('p', [_vm._v("Second Edition")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15c00df3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780891128793_Part03.vue
// module id = 60
// module chunks = 0